export default function eldo_date(value) {
    if (value) {
        return value.substr(4, 2) + '/' + value.substr(6, 2) + '/' + value.substr(0, 4)
    }
    return '';
}